import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Card } from "react-bootstrap";
import logo from "../../../../src/assets/forbidden-lands/forbidden-lands-logo.webp";
import sectionDivider from "../../../../src/assets/forbidden-lands/session14/bitter-reach-page-banner-session-14.webp";
import "../../../index.css";
import { ContentContainer } from "../SessionSection";
import DriveThruAffiliateHeader from "../driveThruAffiliateHeader/driveThruAffiliateHeader.component";
import ModalComponent from "../modal/modal.component";
import ImageComponent from "../image/image.component";
import { useEffect } from "react";
import "./forbidden-lands-styles.scss";

import cover from "../../../../src/assets/forbidden-lands/session14/fbl-session-14-cover.webp";
import erollo from "../../../../src/assets/forbidden-lands/session14/erollo.webp";

const pageHeader = {
  color: "white",
  backgroundColor: "black",
  opacity: "1",
  marginTop: "20px",
  padding: "15px",
};
const cardStyle = {
  textAlign: "left",
  fontFamily: "Carter One",
  backgroundColor: "rgba(0, 0, 0, 1) ",
  color: "white",
  marginBottom: "15px",
};

const FBLSession14 = () => {
  const [showModal, setShowModal] = React.useState("");
  const [modalData, setModalData] = React.useState({});
  const handleClick = (img, body, isLegend, caption) => {
    setModalData({
      body: body,
      image: img,
      isLegend: isLegend,
      caption: caption,
    });
    handleOpenModal();
  };
  const handleOpenModal = () => {
    setShowModal("show");
  };
  const handleCloseModal = () => {
    setShowModal("", "");
  };

  const section1Data = [
    {
      title: "Ex-cons Having a Drink",
      anchor: "freedom-day",
      sectionTitleCssName: "sectionTitleFBL",
      text: (
        <div className="fblBodyText">
          <ImageComponent
            image={erollo}
            caption="Erollo, minstrel"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Erollo: a half-elf frailer minstrel from Alderland. He is as haughty and superior as all the stereotypes imply. His imprisonment on Gomsten for killing
            the wrong person back in Alderland has not dampened his enthusiasm for snobbery and being the life the party."
            isLegend={false}
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          METAGAME: since we now have the potential for four players per
          session, and because Ruenlocke has become the party Stronghold, we
          decided{" "}
          <span style={{ color: "burlywood" }}>
            each player only plays one PC on the field at a time
          </span>{" "}
          and their backup PC will be assumed to be at the stronghold so it is
          not completely vulnerable to takeover.
          <br />
          <br />
          Lobo and Blisster are having a drink at Cuss & Dang's when{" "}
          <span style={{ color: "burlywood" }}>
            fellow Gomsten ex-prisoner Erollo sits down beside them
          </span>
          . Erollo is a half-elf minstrel; a frailer. Erollo is as haughty and
          superior as all the stereotypes imply. His imprisonment on Gomsten for
          killing the wrong person back in Alderland has not dampened his
          enthusiasm for snobbery and being the life the party.
          <br />
          <br />
          When asked if Cuss & Dang would be friends, foes, or neither as fellow
          Frailers from Alderland, Erollo said,{" "}
          <span style={{ color: "lightgreen" }}>
            "They own a tavern. And if you're pouring drinks, you're a friend of
            Erollo!"
          </span>
          . <br />
          <br />
          Erollo is not a muscian minstrel; he is more of a storyteller and
          charismatic presense that is quick to cheer up a friend and insult a
          foe. He has heard of the success of the so-called Brothers of the
          Bitter Reach since their celebration in the town square. Since release
          from Gomsten, Erollo has earned his winter clothes and decent gear,
          but he is anxious to join the brothers and get a slice of that fame
          and fortune.
          <br />
          <br />
          After some shopping for gear, Lobo upgrading from studded leather to
          chainmail, the party decides there is plenty of time for the fishing
          contest, the Sunken City, and sailing with Roebuck. First,{" "}
          <span style={{ color: "burlywood" }}>
            they decide they should investigate the Tower of the Farseers
          </span>{" "}
          and the comet that shot into the sky several nights before the
          Awakening Day festival in Northfall.
          <br />
          <br />
          <a href="#pageTop">Back to Top</a>
        </div>
      ),
    },
  ];
  const section2Data = [
    {
      title: "To the Tower of the Farseers",
      anchor: "freedom-day",
      sectionTitleCssName: "sectionTitleFBL",
      text: (
        <div className="fblBodyText">
          <ImageComponent
            image={cover}
            caption="To the Tower, Part 1"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Fellow ex-prisoner from Gomsten, Erollo the minstrel, catches up
                with the party just in time to begin trek to the Tower of the
                Farseers. What was that comet that shot into the sky and how
                does it relate to Wurda's Legend of The Five Seals?"
            isLegend={false}
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          The party heads south out of Northfall. After crossing the Keld river,
          they attempt to scramble up a steep bank of shale and loose tundra.
          Lobo annouces the ground is unstable and everyone should be careful.
          He then steps on a huge stick with his one good leg. The stick snaps
          like the haft of a battle ax breaking in half: in other words,{" "}
          <span style={{ color: "burlywood" }}>
            Lobo biffs LEAD THE WAY roll and an avalanche of shale, tundra,
            dirt, and filthy snow piles down on the party as they tumble toward
            the rocky shores of the Silver Strait
          </span>
          . <br />
          <br />
          Blisster is hurt and becomes COLD. Lobo is broken by WITS and COLD
          also. Erollo is unhurt. He surfs atop the avalanche and lands on his
          feet next to Lobo laying glassy-eyed on the rocky beach. Erollo sings
          a half-elf song of dancing on top of snow in a snide, but effective,
          use of his Path of the Hynm to bring Lobo to back to his foot. As a
          frailer, his powers are more effective than normal and Lobo's wounded
          pride takes a backseat to his gratitude that he didn't die two hexes
          outside Northfall. Erollo is now best equipped to LEAD THE WAY and
          announces his candidacy by stating,{" "}
          <span style={{ color: "lightgreen" }}>
            "Here gents, let me show you how it's done."
          </span>
          <br />
          <br />
          With two of three party members COLD, the party decides to make camp
          and rest for the night. Everyone has rested nicely, but toward morning
          <span style={{ color: "burlywood" }}>two wolves sneak into camp</span>
          , starving and emboldened.
          <br />
          <br />
          Blisster and Lobo are too deeply asleep, but Erollo wakes up and is
          not surprised. A pitched battle ensues in which wolves are ripping at
          Blisster's prone form. If not for his recent purchase of a leather cap
          as additional armor, he may have been seriously hurt. After a few
          rounds, the party kills the wolves and piles their pelts onto the
          dogsled. Erollo ponders if the party might be better served returning
          to Nortfall whilst it is nearby to hire a proper guide.
          <br />
          <br />
          <small>Attendees: Blisster, Lobo, and Erollo.</small>
          <br />
          <small>Ending Datetime: 6am, Springrise 13, 1165</small>
          <h5>XP</h5>
          <ul>
            <li>Session 1.0</li>
            <li>Legend: 0.0</li>
            <li>Lore: 0.0</li>
            <li>Hex: 1.0</li>
            <li>Pride: 0.0</li>
            <li>Treasure: 0.0</li>
            <li>Monster: 0.0</li>
            <li>Dark Secret: 0.0</li>
            <li>
              <strong>TOTAL: 2.0</strong>
            </li>
          </ul>
          Next session the XP above has to be handed out. Party may decided to
          return to Northfall to hire a guide and Erollo is out of arrows as
          well.
          <br />
          <br />
          <a href="#pageTop">Back to Top</a>
        </div>
      ),
    },
  ];

  useEffect(() => {
    document.body.style.backgroundImage = `url(${require("../../../../src/assets/forbidden-lands/fbl-page-background-blizzard.webp")})`;
    document.body.style.backgroundColor = "#000000";
    document.body.style.backgroundWidth = "100vw";
    document.body.backgroundHeight = "100vh";
    document.body.style.backgroundSize = "cover";
  }, []);

  return (
    <Container>
      <Row>
        <Col>
          <div
            style={{
              backgroundColor: "transparent",
              fontFamily: "IM Fell Great Primer",
            }}
          >
            <div style={pageHeader}>
              <main role="main" className="inner cover text-center">
                <DriveThruAffiliateHeader
                  gameName="Forbidden Lands"
                  logo={logo}
                  productUrl="https://www.drivethrurpg.com/en/product/258593/forbidden-lands-core-game?affiliate_id=844642"
                  logoMaxWidth="200px"
                />
              </main>
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <Card style={cardStyle}>
            <img src={sectionDivider} alt="section divider" />
            <Card.Body>
              <Card.Title
                id="cardTitle-forbidden-lands"
                className="cardTitle-forbidden-lands  "
              >
                Fellow ex-prisoner from Gomsten, Erollo the minstrel, catches up
                with the party just in time to begin trek to the Tower of the
                Farseers. What was that comet that shot into the sky and how
                does it relate to Wurda's Legend of The Five Seals?
                <br />
                <br />
                <small>
                  ⇐ Session 13:{" "}
                  <a href="./forbidden-lands-session-13">The Five Seals</a>☠
                  Session 15:{" "}
                  <a href="./forbidden-lands-session-15">
                    To the Tower, Part 2
                  </a>{" "}
                  ⇒{" "}
                </small>
              </Card.Title>
              <div>
                <ContentContainer data={section1Data} />
              </div>
              <div>
                <ContentContainer data={section2Data} />
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default FBLSession14;
